import React from "react";
import { useNavigate } from "react-router-dom";
import "./SubmissionSuccess.css";

function SubmissionSuccess() {
  const navigate = useNavigate();

  const handleBackToMain = () => {
    navigate("/");
  };

  const handleBookAnother = () => {
    navigate("/book-consultation");
  };

  return (
    <div className="App">
      <title>Consultation Booked — EffiGen LLC</title>
      <meta name="robots" content="noindex, nofollow" />
      <button
        className="back-button"
        onClick={handleBackToMain}
        aria-label="Back to main page"
      >
        ← Back to Main
      </button>

      <div className="submission-success-container">
        <div className="submission-success-content">
          <div className="success-icon">
            <svg
              width="80"
              height="80"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="12"
                cy="12"
                r="10"
                fill="#A68A47"
                stroke="#A68A47"
                strokeWidth="2"
              />
              <path
                d="M8 12l2 2 4-4"
                stroke="#0F0E0B"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          <h1>Thank You!</h1>
          <h2>Your consultation has been successfully scheduled!</h2>

          <p className="success-description">
            Great news! You've successfully booked your free consultation with
            our AI experts. We're excited to discuss how AI can transform your
            business.
          </p>

          <div className="next-steps">
            <h3>What happens next?</h3>
            <ul>
              <li>You'll receive a calendar confirmation email shortly</li>
              <li>Our AI experts will prepare for your specific needs</li>
              <li>
                We'll send you a meeting reminder before your consultation
              </li>
              <li>Get ready to explore AI solutions for your business</li>
              <li>
                FYI: Google may include "Invitation from an unknown sender" in
                the meeting title for new emails you interact with. It's just
                us.
              </li>
            </ul>
          </div>

          <div className="action-buttons">
            <button className="primary-button" onClick={handleBackToMain}>
              Return to Main Page
            </button>
            <button className="secondary-button" onClick={handleBookAnother}>
              Schedule Another Meeting
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SubmissionSuccess;
